import { fetchCurrentUser } from '../../ducks/user.duck';
import { onCustomerGroupPaymentCollectionCancel, onCustomerGroupPaymentCollectionFind, onCustomerGroupPaymentInvoiceCollectionFind, onSingleMailApiCollection } from '../../util/api';
import { storableError } from "../../util/errors";
import { GROUP_PAYMENT_PAGE_SCHEDULED_PAYMENTS, GROUP_PAYMENT_RECURRING_CANCELLED_INVOICE_TEMPLATE_ID } from '../../util/types';
import { parse } from "../../util/urlHelpers";

// ================ Action types ================ //

export const FETCH_TRANSACTIONS_REQUEST = 'app/GroupPaymentHistoryPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/GroupPaymentHistoryPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/GroupPaymentHistoryPage/FETCH_TRANSACTIONS_ERROR';

export const CANCEL_TRANSACTIONS_REQUEST = 'app/GroupPaymentHistoryPage/CANCEL_TRANSACTIONS_REQUEST';
export const CANCEL_TRANSACTIONS_SUCCESS = 'app/GroupPaymentHistoryPage/CANCEL_TRANSACTIONS_SUCCESS';
export const CANCEL_TRANSACTIONS_ERROR = 'app/GroupPaymentHistoryPage/CANCEL_TRANSACTIONS_ERROR';

const TRANSACTION_PER_PAGE = 10;

// ================ Reducer ================ //

const initialState = {
  transactions: [],
  pagination: null,
  fetchTransactionsError: null,
  transactionInProgress: false,
  cancelInProgress: false,
  cancelError: false
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

    case FETCH_TRANSACTIONS_REQUEST:
      return {
        ...state,
        transactionInProgress: true,
        fetchTransactionsError: null,
      };

    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactionInProgress: false,
        transactions: payload.data,
        pagination: payload.pagination,
      };

    case FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        transactionInProgress: false,
        fetchTransactionsError: payload,
      };

    case CANCEL_TRANSACTIONS_REQUEST:
      return {
        ...state,
        cancelInProgress: payload,
        cancelError: null,
      };

    case CANCEL_TRANSACTIONS_SUCCESS:
      const transactions = state.transactions.map((st) => st["_id"] == payload["_id"] ? payload : st);
      return {
        ...state,
        transactions: transactions,
        cancelInProgress: false,
        cancelError: null,
      };

    case CANCEL_TRANSACTIONS_ERROR:
      return {
        ...state,
        cancelInProgress: false,
        cancelError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //
// Action Creators
export const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
export const fetchTransactionsSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response
});
export const fetchTransactionsError = error => ({
  type: FETCH_TRANSACTIONS_ERROR,
  payload: error
});

export const cancelTransactionsRequest = (id) => ({ type: CANCEL_TRANSACTIONS_REQUEST, payload: id });
export const cancelTransactionsSuccess = response => ({
  type: CANCEL_TRANSACTIONS_SUCCESS,
  payload: response
});
export const cancelTransactionsError = error => ({
  type: CANCEL_TRANSACTIONS_ERROR,
  payload: error
});

// ================ Thunks ================ //
export const fetchTransactions = (params, tab) => async (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsRequest());
  try {
    const {
      pageParams,
      payload,
    } = params;
    const response = tab == GROUP_PAYMENT_PAGE_SCHEDULED_PAYMENTS ? await onCustomerGroupPaymentCollectionFind({
      payload,
      pageParams,
    }) : await onCustomerGroupPaymentInvoiceCollectionFind({
      payload,
      pageParams,
    });
    dispatch(fetchTransactionsSuccess(response));
    return response;
  } catch (error) {
    console.log(error, '&&& &&& => error');

    const errorMessage = storableError(error)
    dispatch(fetchTransactionsError(errorMessage));
    throw error;
  }
};

export const cancelTransaction = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(cancelTransactionsRequest(params["_id"]));
    const {
      stripeSubscriptionId,
      groupName,
      paymentName
    } = params;
    const response = await onCustomerGroupPaymentCollectionCancel({
      filter: { stripeSubscriptionId }, payload: { stripeStatus: "canceled" }
    });

    // When a user cancels their recurring group payment, they need to receive an email notification confirming that they canceled successfully and will no longer be charged moving forward
    try {
      const currentUser = getState().user.currentUser;
      const { email, profile } = currentUser?.attributes || {};
      const { firstName = '', lastName = '' } = profile || {};
      // TSET
      const sendMailData = {
        template_id: GROUP_PAYMENT_RECURRING_CANCELLED_INVOICE_TEMPLATE_ID,
        data: {
          email: email,
          name: `${firstName} ${lastName}`,
          paymentName,
          groupName,
          redirectURL: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/group-payment-history/scheduled_payments`
        }
      };
      await onSingleMailApiCollection(sendMailData)
    } catch (error) {
      console.log(error, '&&& &&& => error');
    }
    dispatch(cancelTransactionsSuccess(response.data));
    return response;
  } catch (error) {
    console.log(error, '&&& &&& => error');
    const errorMessage = storableError(error)
    dispatch(cancelTransactionsError(errorMessage));
    return error;
  }
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { tab } = params;
  dispatch(fetchTransactionsRequest());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  const queryParams = parse(search);
  const { page = 1 } = queryParams;

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions))
    .then(response => {
      const currentUser = getState().user.currentUser;
      const userId = currentUser.id.uuid;

      if (userId) {
        return dispatch(fetchTransactions(
          {
            payload: {
              userId: currentUser.id.uuid,
              ...(tab == GROUP_PAYMENT_PAGE_SCHEDULED_PAYMENTS ? {
                type: "monthly",
                status: "recurring",
                stripeStatus: { $in: ["active", "past_due", "trialing", "paused", "past_due", "incomplete", "incomplete_expired"] }
              } : {}),
            },
            pageParams: {
              page,
              perPage: TRANSACTION_PER_PAGE
            },
            isAdmin: true
          }, tab));
      }

      return response;
    });
};
